import { motion, useReducedMotion } from 'framer-motion';

const DESTINATIONS = [
  'Ликийское побережье',
  'Грузия',
  'Черногория',
  'Каппадокия',
  'Армения',
  'Сицилия',
  'Португалия',
  'Албания',
  'Кипр',
  'Марокко',
  'Вьетнам',
  'Дагестан',
];

/**
 * Infinite marquee.
 *
 * The list is rendered twice and translated by exactly -50%, which is what makes
 * the loop seamless without measuring anything. Pauses on hover, and under
 * reduced motion it degrades to a plain wrapped list rather than freezing
 * mid-scroll with items cut off.
 */
export function DestinationMarquee() {
  const reduced = useReducedMotion();

  if (reduced) {
    return (
      <section className="border-y border-[var(--border-subtle)] py-6">
        <div className="container-page flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm text-[var(--text-muted)]">
          {DESTINATIONS.map((item) => (
            <span key={item}>{item}</span>
          ))}
        </div>
      </section>
    );
  }

  return (
    <section
      aria-label="Направления"
      className="group relative overflow-hidden border-y border-[var(--border-subtle)] py-6"
    >
      <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-24 bg-gradient-to-r from-[var(--surface)] to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-24 bg-gradient-to-l from-[var(--surface)] to-transparent" />

      <motion.div
        className="flex w-max gap-10 group-hover:[animation-play-state:paused]"
        animate={{ x: ['0%', '-50%'] }}
        transition={{ duration: 42, repeat: Infinity, ease: 'linear' }}
      >
        {[0, 1].map((copy) => (
          <div key={copy} className="flex shrink-0 items-center gap-10" aria-hidden={copy === 1}>
            {DESTINATIONS.map((item) => (
              <span
                key={`${copy}-${item}`}
                className="flex shrink-0 items-center gap-10 text-sm tracking-wide text-[var(--text-muted)]"
              >
                {item}
                <span className="size-1 rounded-full bg-clay-500/60" />
              </span>
            ))}
          </div>
        ))}
      </motion.div>
    </section>
  );
}
